// TODO: is this still needed, or was it a polyfill for something?
export default function handlePopState(popState) {
    const location = window.history.location || window.location;

    $(window).on('popstate', function (e) {
        popState(location.href);
    });
}
